<template>
    <div class="image-preview-modal">
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div ref="dynamicDialog" class="modal">
            <div class="modal__header">
                <h2 class="headline-s" v-if="resourceName == null">Preview Image</h2>
                <h2 class="headline-s" v-else>Preview {{resourceName}}</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close"/>
            </div>
            <div class="modal__body" >
                <div class="modal__body--image">
                    <img :src="imageUrl" alt="Product Image">
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { inject, ref } from "vue";
    import { onClickOutside } from "@vueuse/core";
    import CloseIcon from "@icons/closeIcon.svg";
    const dialogRef = inject('dialogRef');
    let dynamicDialog = ref();

    let imageUrl = dialogRef?.value?.data?.image_url ?? null;
    let resourceName = dialogRef?.value?.data?.resource_name ?? null;
    const closeDialog = () => {
        dialogRef?.value?.close();
    };
    onClickOutside(dynamicDialog, ()=>{
        closeDialog();
    });
</script>